module.exports = __webpack_public_path__ + "static/media/icon-right.94453b78.svg";